import type { ContractorTranslation } from './en';

export const it: ContractorTranslation = {
  common: {
    cancel: 'Annulla',
    save: 'Salva',
    retry: 'Riprova',
    download: 'Scarica',
    continue: 'Continua',
    yes: 'Sì',
    no: 'No',
    genericError: 'Qualcosa è andato storto. Riprova.',
    networkError: 'Impossibile raggiungere DubForge. Controlla la connessione a internet.',
  },
  app: {
    tagline: 'Incarichi di doppiaggio, file e revisioni in un unico posto.',
    startupFailed: 'Impossibile avviare DubForge',
    notFoundTitle: 'Pagina non trovata',
    notFoundBody: 'Questa pagina non esiste o non hai i permessi per vederla.',
    goHome: 'Torna alla home',
    crashTitle: 'Qualcosa è andato storto',
    crashBody: 'Prova a ricaricare la pagina.',
    reload: 'Ricarica',
  },
  language: {
    label: 'Lingua',
    change: 'Cambia lingua',
  },
  welcome: {
    title: 'Ti diamo il benvenuto su DubForge',
    body: 'Scegli la tua lingua. DubForge e le tue notifiche di Discord la useranno.',
    changeLater: 'Puoi cambiarla in qualsiasi momento dal menu della lingua in alto a destra.',
  },
  nav: {
    myAssignments: 'I miei incarichi',
    openMenu: 'Apri menu',
    account: 'Account',
    notificationEmail: 'Email per le notifiche',
    signOut: 'Esci',
    roleAdmin: 'Amministrazione',
    roleContractor: 'Doppiaggio',
    lightMode: 'Modalità chiara',
    darkMode: 'Modalità scura',
  },
  login: {
    signIn: 'Accedi con Discord',
    onlyInvited: 'Solo gli account Discord aggiunti dal proprietario del canale possono accedere.',
    signingIn: 'Accesso in corso…',
    backToSignIn: "Torna all'accesso",
    failed: 'Accesso non riuscito. Riprova.',
  },
  authErrors: {
    not_invited:
      'Questo account Discord non è stato aggiunto a DubForge. Chiedi al proprietario del canale di aggiungerti.',
    access_off: 'Il tuo accesso a DubForge è stato disattivato.',
    discord_only: 'Puoi accedere solo con Discord.',
  },
  errors: {
    not_signed_in: 'La sessione è scaduta. Accedi di nuovo.',
    access_off: 'Il tuo accesso a DubForge è stato disattivato.',
    admins_only: 'Non hai il permesso di farlo.',
    not_found: 'Questo elemento non esiste o non è più disponibile.',
    invalid_request: 'Qualcosa nella richiesta non è valido. Controlla e riprova.',
    conflict: 'Esiste già.',
    already_approved: 'Questo incarico è già stato approvato, quindi non servono altri caricamenti.',
    not_audio: 'Puoi caricare solo file WAV o MP3. Carica solo la tua traccia vocale.',
    upload_incomplete: 'Il caricamento non è stato completato. Riprova.',
    discord_unreachable: 'Impossibile raggiungere Discord. Riprova più tardi.',
    server_error: 'Qualcosa è andato storto da parte nostra. Riprova.',
  },
  notifications: {
    title: 'Notifiche',
    openWithCount: 'Notifiche ({{count}} da leggere)',
    markAllRead: 'Segna tutte come lette',
    empty: 'Ancora niente.',
  },
  emailSettings: {
    body: "Ti mandiamo un'email quando ricevi un nuovo incarico e quando il tuo lavoro è stato revisionato.",
    label: 'Indirizzo email',
    fromDiscord: 'Presa dal tuo account Discord. Cambiala se preferisci un altro indirizzo.',
    saved: 'Indirizzo email salvato',
    invalid: 'Inserisci un indirizzo email valido.',
    missing: 'Nessun indirizzo email ancora. Aggiungine uno per ricevere le notifiche.',
  },
  status: {
    Assigned: 'Assegnato',
    InProgress: 'In corso',
    Submitted: 'In attesa di revisione',
    ChangesRequested: 'Modifiche richieste',
    Approved: 'Approvato',
  },
  assetKind: {
    package: 'Pacchetto di doppiaggio (video + voce + SFX)',
    video: 'Video di riferimento (720p)',
    sfx: 'Traccia SFX / musica',
    voice: 'Traccia vocale originale',
    script: 'Copione',
    other: 'Altro',
  },
  translation: {
    machine: 'Traduzione automatica',
    showOriginal: 'Mostra originale',
    showTranslation: 'Mostra traduzione',
  },
  uploader: {
    progress: '{{percent}}% di {{size}}',
    queued: 'In attesa di caricamento: {{count}}',
    keepOpen: 'Tieni aperta questa scheda finché non finisce.',
    cancelled: 'Caricamento annullato',
    done: '{{name}} caricato',
    failed: 'Caricamento non riuscito: {{error}}',
  },
  my: {
    greeting: 'Ciao, {{name}}',
    subtitle: 'I tuoi incarichi di doppiaggio.',
    emptyTitle: 'Ancora nessun incarico',
    emptyBody: 'Quando ti verrà assegnato un video riceverai un messaggio su Discord e lo vedrai qui.',
    todo: 'Da fare',
    waiting: 'In attesa di revisione',
    done: 'Completati',
    updated: 'Aggiornato {{when}}',
  },
  assignment: {
    back: 'I miei incarichi',
    dubIn: 'Doppiaggio: {{language}}',
    paid: 'Pagato',
    next: {
      Assigned: 'Scarica i file sorgente, registra la tua voce e poi carica qui la tua traccia vocale.',
      InProgress: 'Quando la tua traccia vocale è pronta, caricala qui sotto.',
      Submitted:
        'Il tuo doppiaggio è stato inviato per la revisione. Riceverai un messaggio su Discord quando sarà stato revisionato.',
      ChangesRequested: 'Sono state richieste delle modifiche. Leggi il feedback qui sotto, poi carica una nuova versione.',
      Approved: 'Approvato. Grazie!',
    },
    notes: 'Note',
    sourceFiles: 'File sorgente',
    noFiles: 'Non è stato ancora caricato nessun file.',
    fileInfo: '{{kind}} · {{size}}',
    packageHint: 'Un unico .mp4 con il video e due tracce audio: la traccia 1 contiene le battute originali, la traccia 2 gli SFX.',
    uploadTitle: 'Carica la tua traccia vocale',
    voiceOnlyTitle: 'Solo la tua voce',
    voiceOnlyBody:
      "Carica solo la tua voce registrata: niente musica, niente effetti sonori e niente dell'audio originale. Assicurati che abbia la stessa durata dell'originale.",
    voiceOnlyConfirm: 'Questo file contiene solo le battute registrate.',
    dropLabel: 'Carica qui la traccia vocale',
    dropHint: 'Solo WAV o MP3.',
    noteForReviewer: 'Nota per chi revisiona (facoltativa)',
    lengthTitle: 'La durata non corrisponde',
    lengthBody:
      'Il tuo file dura {{dub}}, ma la traccia SFX dura {{sfx}}. Se la tua traccia inizia in un punto diverso o è tagliata, non sarà sincronizzata con il video. Vuoi caricarla comunque?',
    uploadAnyway: 'Carica comunque',
    chooseAnother: 'Scegli un altro file',
    versions: 'Versioni caricate',
    nothingUploaded: 'Non hai ancora caricato niente.',
    version: 'Versione {{version}}',
    reviewApproved: 'Approvata',
    reviewChanges: 'Modifiche richieste',
    reviewPending: 'In attesa di revisione',
    yourNote: 'La tua nota:',
    feedback: 'Feedback',
    listen: 'Ascolta',
    uploadedOn: '{{date}} · {{size}}',
    length: 'Durata: {{duration}}',
  },
};
